import { NORM_TREATY_SURPLUS_INIT_LOADING, NORM_TREATY_SURPLUS_INIT_SUCCESS, NORM_TREATY_SURPLUS_INIT_FAIL, NORM_TREATY_SURPLUS_ACCUM_TYPES } from '@/store/types'
import http from '@/utils/ajax'
import { extractMenu, extractMessages } from '@/utils/extract'
import clone from 'clone'

export const initialState = {
  // 0: Loading, 1: Success, 2: Fail
  init: 0,
  initErr: [],
  // Data
  accumTypes: [],
  accumTypeMap: {},
  supportedFormat: [],
  // API menu
  menu: {}
}

export const getters = {

}

export const mutations = {
  [NORM_TREATY_SURPLUS_INIT_LOADING](state) {
    state.init = 0
    state.menu = {}
    state.initErr = []
  },
  [NORM_TREATY_SURPLUS_INIT_SUCCESS](state, data) {
    state.init = 1
    state.menu = data ? data.menu : null
    state.supportedFormat = data ? data.supportedFormat : []
    state.initErr = []
  },
  [NORM_TREATY_SURPLUS_INIT_FAIL](state, err) {
    state.init = 2
    state.menu = {}
    state.initErr = err
  },
  [NORM_TREATY_SURPLUS_ACCUM_TYPES](state, data) {
    state.accumTypes = data
    let accumTypeMap = {}
    for (var accumType of data) {
      accumType.label = accumType.accmType + ' - ' + accumType.accmTypeDesc
      accumTypeMap[accumType.accmType] = accumType
    }
    state.accumTypeMap = accumTypeMap
  }
}

const actions = {
  async normTreatySurplusInit({ commit, rootState }) {
    const apiUrl = rootState.app.menu.normTreatySurplus
    commit(NORM_TREATY_SURPLUS_INIT_LOADING)
    if (apiUrl) {
      try {
        const result = await http.get(apiUrl)
        const menu = extractMenu(result.data._links)
        const commitResult = {
          menu: menu,
          supportedFormat: result.data.data.format
        }
        commit(NORM_TREATY_SURPLUS_INIT_SUCCESS, commitResult)
      } catch (error) {
        commit(NORM_TREATY_SURPLUS_INIT_FAIL, extractMessages(error))
      }
    }
  },
  async nts_loadAccumTypes({ commit, state }) {
    const apiUrl = state.menu.accumTypes
    const { data } = await http.get(apiUrl)
    commit(NORM_TREATY_SURPLUS_ACCUM_TYPES, data.data)
  }
}

export default {
  state: clone(initialState),
  getters,
  mutations,
  actions
}
